module.exports = __webpack_public_path__ + "static/media/MY-UTN.a0266b7e.png";